import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useParams } from "react-router-dom";
import "./AutoComplete.scss";

const AutoComplete = ({ onChange, value, name, isDisabled, disabled }) => {
  const isComponentDisabled = Boolean(isDisabled || disabled);
  const [lang] = useState(
    sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en"
  );

  const params = useParams();
  // eslint-disable-next-line no-unused-vars
  const [channel, setChannel] = useState(params.channel);

  // console.log("cahnnel in auto complete",channel);


  // eslint-disable-next-line no-unused-vars
  const { t, i18n } = useTranslation();
  useEffect(() => {
    changeLanguage(lang ? lang : sessionStorage.getItem("lang"));
  }, [lang]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const options = (channel === "carsecure" || channel === "domesticsecure" || channel === "branchdomestic") ? omanCountry : uatContries;

  const selectedOption = useMemo(() => {
    if (!value) return null;

    let phoneVal = "";
    let codeVal = "";

    if (typeof value === "string") {
      phoneVal = value;
      codeVal = value;
    } else if (typeof value === "object") {
      phoneVal = value.phone || "";
      codeVal = value.code || "";
    }

    if (!phoneVal && !codeVal) return null;

    const matched = options.find(
      (opt) =>
        (phoneVal && opt.phone === phoneVal) ||
        (codeVal && opt.code === codeVal)
    );

    if (matched) return matched;

    if (typeof value === "object" && value.code && value.phone) {
      return value;
    }

    return null;
  }, [value, options]);

  return (
    <Autocomplete
      id="country-select-demo"
      sx={{
        "& .MuiInputBase-root": {
          backgroundColor: "#ffffff",
          fontFamily: "Rubik, sans-serif",
          fontWeight: "500",
          color: "#171747",
        },
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#ffffff",
          "&:hover": {
            backgroundColor: "#ffffff",
          },
          "&.Mui-focused": {
            backgroundColor: "#ffffff",
          },
        },
        "& .MuiAutocomplete-inputRoot": {
          backgroundColor: "#ffffff",
        },
        "& .MuiInputLabel-root": {
          fontFamily: "Rubik, sans-serif",
          fontWeight: "500",
          color: "#171747",
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "#171747",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#c4c4c4",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#171747",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#171747",
        },
        ...(isComponentDisabled && {
          pointerEvents: "none",
          cursor: "not-allowed",
          opacity: 0.85,
        }),
      }}
      onChange={onChange}
      value={selectedOption || null}
      name={name}
      options={options}
      disabled={isComponentDisabled}
      autoHighlight
      getOptionLabel={(option) => {
        if (typeof option === "string") return option;
        return option?.phone || "";
      }}
      isOptionEqualToValue={(option, val) => {
        if (!option || !val) return false;
        return option.phone === val.phone || option.code === val.code;
      }}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{
            "& > img": { mr: lang === "ar" ? 0.75 : 1, ml: lang === "ar" ? 1 : 0.75, flexShrink: 0 },
            fontFamily: "Rubik, sans-serif",
            fontSize: "0.90rem",
            fontWeight: "500",
            color: "#171747",
            backgroundColor: "#ffffff",
            "&:hover": {
              backgroundColor: "#f5f5f5 !important",
            },
          }}
          {...props}
        >
          <img
            loading="lazy"
            width="20"
            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
            alt={option.label}
          />
          {option.phone}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          sx={{
            fontSize: "1rem",
            backgroundColor: "#ffffff",
            "& .MuiInputBase-root": {
              backgroundColor: "#ffffff",
              fontFamily: "Rubik, sans-serif",
            },
          }}
          {...params}
          label={lang === "ar" ? "رمز البلد" : "Country Code"}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                {selectedOption && selectedOption.code ? (
                  <Box
                    component="span"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mr: lang === "ar" ? 0.5 : 0.75,
                      ml: lang === "ar" ? 0.75 : 0.5,
                      flexShrink: 0,
                    }}
                  >
                    <img
                      loading="lazy"
                      width="20"
                      srcSet={`https://flagcdn.com/w40/${selectedOption.code.toLowerCase()}.png 2x`}
                      src={`https://flagcdn.com/w20/${selectedOption.code.toLowerCase()}.png`}
                      alt={selectedOption.label || ""}
                      style={{ display: "block", width: "20px", height: "auto" }}
                    />
                  </Box>
                ) : null}
                {params.InputProps.startAdornment}
              </>
            ),
          }}
          inputProps={{
            ...params.inputProps,
            autoComplete: "off",
          }}
        />
      )}
    />
  );
}

export default AutoComplete;



const uatContries = [
  {
    code: 'AE',
    label: 'United Arab Emirates',
    phone: '+971',
  },
  { code: 'OM', label: 'Oman', phone: '+968' },
  { code: 'IN', label: 'India', phone: '+91' }
]

const omanCountry = [
  { code: 'OM', label: 'Oman', phone: '+968' },
]